module.exports = __webpack_public_path__ + "img/40_38_078_030.1f260d03.jpg";